// extracted by mini-css-extract-plugin
export default {"more":"g0e1kGxTbI8ePgFTWmia"};